import ComposioAppIcon from '@/frontend/components/Integrations/ComposioAppIcon'
import { CredentialsIcon } from '@/frontend/components/Integrations/integrationIcons'
import { BUILTIN_ICONS } from '@/frontend/pages/Dashboard/Integrations/constants'
import ConnectorIcon from '@/frontend/features/Fde/data/ConnectorIcon'
import type { AdminResource } from '@/frontend/features/IntegrationAccess/types'

export default function ConnectionIcon({ resource }: { resource: AdminResource }) {
  const brand = resource.branding
  const icon = brand.kind === 'builtin' ? BUILTIN_ICONS[brand.slug]
    : brand.kind === 'credential' ? <CredentialsIcon className="size-5" />
    : brand.kind === 'forge' ? <ConnectorIcon iconUrl={brand.logo} imageClassName="size-6" fallbackClassName="size-5" />
    : <ComposioAppIcon key={`${brand.slug}:${brand.logo}`} logo={brand.logo} name={brand.name} className="size-6" />
  return <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-border bg-background [&>svg]:size-6" aria-label={brand.name}>{icon}</span>
}
